import { useContext } from 'react';

import { UserContext } from 'Context/user';

export const useFetchUserStateData = () => {
  const { userState } = useContext(UserContext);

  if (!userState) {
    return null;
  }

  return ({
    dpSellerId: userState.dpSellerId,
    email: userState.email,
  });
};
